import CardFeed from '@ifit/mp-card-feed';
import { getUserNavigationHandler, ROWTITLES } from '../../util/navigation-utils';
import { globalizeCompletedDate } from '../../util/date-utils';
import { getResizedImageUrl } from '../../util/get-resized-image-url';
import { IStaffPickAndDetails } from './index';
import { DefaultImages } from '@ifit/img/out/defaults';
import { GlobalText } from '../../i18n/global-text';

interface IFeaturedItemProps {
  item: IStaffPickAndDetails;
}

export default function FeaturedItem({ item }: IFeaturedItemProps): JSX.Element {
  const { staffPick, userWorkoutDetail, userSeriesDetail } = item;

  let tagPrimary: string;
  let tagSecondary: string;
  let locked: boolean;
  let completedDate = null;
  let url: string = null;
  if (staffPick.type === 'program') {
    const statWorkoutCount = staffPick.program?.workouts.length;
    tagPrimary = GlobalText.numberOfWorkouts(statWorkoutCount);
    tagSecondary = null;
    locked = userSeriesDetail?.locked;
    completedDate = userSeriesDetail?.completedDate;
    url = staffPick.program.url;
  } else {
    tagPrimary = userWorkoutDetail?.estimates.duration;
    tagSecondary = userWorkoutDetail?.estimates.distance;
    locked = userWorkoutDetail?.locked;
    completedDate = userWorkoutDetail?.completedDate;
    url = staffPick.workout.url;
  }

  const clickHandler = getUserNavigationHandler(url, ROWTITLES.FEATURED_ITEM);

  const imageUrl = staffPick?.images?.coverImage || staffPick?.images?.largeImage || staffPick?.images?.thumbnail;
  const resizedImageUrl = getResizedImageUrl(imageUrl, DefaultImages.Hero, { width: 560, height: 360 });

  return (
    <CardFeed
      title={staffPick.title}
      imageUrl={resizedImageUrl}
      onClick={clickHandler}
      tagPrimary={tagPrimary}
      tagSecondary={tagSecondary}
      locked={locked}
      completed={globalizeCompletedDate(completedDate)}
    />
  );
}
